export default "__VITE_PUBLIC_ASSET__950b28d3__"